import usePrimaryInputMethod, { InputMethod } from './usePrimaryInputMethod';

export default function useHasTouch() {
  const { type } = usePrimaryInputMethod();
  return type === InputMethod.TOUCH || type === InputMethod.STYLUS;
}
